import script from "./CartComment.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartComment.vue?vue&type=script&setup=true&lang=ts"

import "./CartComment.vue?vue&type=style&index=0&id=5d72c39d&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d72c39d"]])

export default __exports__